var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisualizationTimeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.74639 10.0301L3.42576 4.36328C1.80815 5.81356 0.807617 7.81707 0.807617 10.0301H9.74639Z",
    fill: "#2D65BC",
    stroke: "#2D65BC",
    strokeWidth: 0.734582,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M9.7457 10.0297L6.83259 7.41797L3.82959 10.0297H9.7457Z",
    fill: "#10CBCE",
    stroke: "#10CBCE",
    strokeWidth: 0.734582,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.48828 10.0273C2.48828 11.8239 3.3006 13.4505 4.61389 14.6279L9.7453 10.0273H2.48828Z",
    fill: "#91EECC",
    stroke: "#2D65BC",
    strokeWidth: 0.734582,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M4.61422 14.6279L9.74564 10.0273H6.7328L3.29883 13.0137C3.64219 13.6092 4.08586 14.1536 4.61422 14.6279Z",
    fill: "#10CBCE",
    stroke: "#10CBCE",
    strokeWidth: 0.734582,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.74458 10.0273L5.99902 13.3854C6.49036 13.8271 7.07419 14.1773 7.71698 14.416C8.35977 14.6547 9.04884 14.7771 9.74458 14.7763V10.0273Z",
    fill: "#F4FFDF",
    stroke: "#2D65BC",
    strokeWidth: 0.734582,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M9.74573 14.7722V12.1484L7.33008 14.2491C8.07729 14.5936 8.90552 14.7729 9.74573 14.7722Z",
    fill: "#10CBCE",
    stroke: "#10CBCE",
    strokeWidth: 0.734582,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.74316 10.0273V18.0028C12.1995 18.0028 14.4235 17.1102 16.0334 15.6668L9.74316 10.0273Z",
    fill: "#10CBCE",
    stroke: "#2D65BC",
    strokeWidth: 0.734582,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M16.0339 15.6684L14.3255 14.1367L9.88135 18.0012C12.193 17.9725 14.4007 17.1355 16.0339 15.6684Z",
    fill: "#10CBCE",
    stroke: "#10CBCE",
    strokeWidth: 0.734582,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9.74316 10.0273L12.7228 12.6987C13.1146 12.3483 13.4254 11.9319 13.6372 11.4734C13.849 11.015 13.9576 10.5236 13.9569 10.0273H9.74316Z",
    fill: "#2D65BC",
    stroke: "#2D65BC",
    strokeWidth: 0.734582,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M13.9569 10.0273H9.74316L12.7228 12.6987C13.1146 12.3483 13.4254 11.9319 13.6372 11.4734C13.849 11.015 13.9576 10.5236 13.9569 10.0273Z",
    fill: "#10CBCE",
    stroke: "#10CBCE",
    strokeWidth: 0.734582,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M9.74316 10.0101H16.3644C16.3644 8.37073 15.6232 6.88667 14.4251 5.8125L9.74316 10.0101Z",
    fill: "#91EECC",
    stroke: "#2D65BC",
    strokeWidth: 0.734582,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M16.3648 10.0164C16.3668 8.83425 15.9734 7.67874 15.2352 6.69922L13.8042 10.0164H16.3648Z",
    fill: "#10CBCE",
    stroke: "#10CBCE",
    strokeWidth: 0.734582,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8636 3.64323C15.0418 2.01015 12.5253 1 9.74561 1V10.0249L16.8636 3.64323Z",
    fill: "#F4FFDF",
    stroke: "#2D65BC",
    strokeWidth: 0.734582,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M16.8642 3.64633C16.0331 2.90167 15.0633 2.29296 13.9984 1.84766L10.4448 9.40167L16.8642 3.64633Z",
    fill: "#10CBCE",
    stroke: "#10CBCE",
    strokeWidth: 0.734582,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M9.74382 4.5625C8.063 4.5625 6.54137 5.17325 5.43994 6.16074L9.74382 10.0194V4.5625Z",
    fill: "#10CBCE",
    stroke: "#2D65BC",
    strokeWidth: 0.734582,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M9.74551 10.0238V5.66797L7.2793 7.81274L9.74551 10.0238Z",
    fill: "#10CBCE",
    stroke: "#10CBCE",
    strokeWidth: 0.734582,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M9.74653 11.9185C10.9101 11.9185 11.8534 11.0728 11.8534 10.0295C11.8534 8.98633 10.9101 8.14062 9.74653 8.14062C8.58293 8.14062 7.63965 8.98633 7.63965 10.0295C7.63965 11.0728 8.58293 11.9185 9.74653 11.9185Z",
    fill: "#1E2D6D",
    stroke: "#2D65BC",
    strokeWidth: 0.734582,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M8.77148 9.26456C8.96859 8.99004 9.26379 8.88762 9.62547 8.94513L8.77148 9.26456Z",
    fill: "#1E2D6D"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M8.77148 9.26456C8.96859 8.99004 9.26379 8.88762 9.62547 8.94513",
    stroke: "#1E2D6D",
    strokeWidth: 0.734582,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M8.63133 10.5513C8.61117 10.5139 8.59228 10.4759 8.57471 10.4375L8.63133 10.5513Z",
    fill: "#1E2D6D"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M8.63133 10.5513C8.61117 10.5139 8.59228 10.4759 8.57471 10.4375",
    stroke: "#1E2D6D",
    strokeWidth: 0.734582,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisualizationTimeIcon);
export default __webpack_public_path__ + "static/media/visualizationTimeIcon.fd98a15962fa9028dd538e2e61b90310.svg";
export { ForwardRef as ReactComponent };